import * as types from '../actions/types'
import Immutable from 'immutable'
import moment from 'moment';
import { isPrimitive } from '../utils/helpers';


const INITIAL_STATE = Immutable.fromJS({
    numberRegisters: 100,
    total: 0,
    purchasing_manager: null,
    storage_manage: null,
    cenco: null,
    total_storage: '',
    storage: '',
    request_type: false,
    reportToGet: 'provider_evaluation',    
    initial_date: '',
    final_date: '',
    provider_evaluation: {
        orderBy: {
            field: null,
            asc: false,
        },
        data: [],
        accumulate: [],
        state_eval: '',
        provider: null,
        initial_date: '',
        final_date: '',
        modalFilter: {
            show: false,
            columns: [],
            filters: []
        },
        //Paginacion
        page: 1,
        showRecords: 100,
        totalRecords: 0,
    },
    contracted_amount_providers: {
        orderBy: {
            field: null,
            asc: false,
        },
        data: [],
        modalFilter: {
            show: false,
            columns: [],
            filters: []
        },
        provider: null,
        initial_date: '',
        final_date: '',
        //Paginacion
        page: 1,
        showRecords: 100,
        totalRecords: 0,  
    },
    contracted_amount_cencos: {
        orderBy: {
            field: null,
            asc: false,
        },
        data: [],
        modalFilter: {
            show: false,
            columns: [],
            filters: []
        },
        initial_date: '',
        final_date: '',
        //Paginacion
        page: 1,
        showRecords: 100,
        totalRecords: 0,
    },
    compliance_purchasing_manager: {
        orderBy: {
            field: null,
            asc: false,
        },
        data: [],
        modalFilter: {
            show: false,
            columns: [],
            filters: []
        },
        initial_date: '',
        final_date: '',
        //Paginacion
        page: 1,
        showRecords: 100,
        totalRecords: 0,
    },
    radicados: {
        orderBy: {
            field: null,
            asc: false,
        },
        data: [],
        modalFilter: {
            show: false,
            columns: [],
            filters: []
        },
        initial_date: '',
        final_date: '',
        //Paginacion
        page: 1,
        showRecords: 100,
        totalRecords: 0,        
    },
    manage_purchasing_manager: {
        orderBy: {
            field: null,
            asc: false,
        },
        data: [],
        modalFilter: {
            show: false,
            columns: [],
            filters: []
        },
        accumulate: [],
        initial_date: '',
        final_date: '',
        show_request_type: false,
        //Paginacion
        page: 1,
        showRecords: 100,
        totalRecords: 0,        
    },
    document_reporter: {
        initial_date: '',
        final_date: ''
    }
    
})

export default function (state = INITIAL_STATE, action) {

    const reportToGet = state.get('reportToGet')
    const columnas = state.getIn([reportToGet, 'modalFilter', 'columns'])

    switch (action.type) {

        // case types.MODIFICAR_NUMERO_REGISTROS_MOSTRAR:
        //     return state.setIn(['numberRegisters'], action.number);

        case types.MODIFICAR_NUMERO_REGISTROS_MOSTRAR:
            state = state.setIn([action.reportToGet, 'showRecords'], Number(action.number))
            return state

        case types.MODIFICAR_INPUTS_REPORTES:
            if (isPrimitive(action.payload.value)) {
                state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value);
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value);
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value));
                }
            }
            return state
        case types.ORDENAR_REPORTES:
            state = state.setIn([action.payload.reportToGet, 'orderBy'], action.payload.orderBy);
            state = state.set('reportToGet', action.payload.reportToGet);
            return state;
        case types.OBTENER_EVALUACION_PROVEEDOR:
            state = state.setIn(['provider_evaluation', 'data'], Immutable.fromJS(action.payload.data))
            state = state.setIn(['provider_evaluation', 'page'], action.payload.page);
            state = state.setIn(['provider_evaluation', 'totalRecords'], action.payload.totalRecords)
            state = state.setIn(['provider_evaluation', 'accumulate'], Immutable.fromJS(action.payload.accumulate))
            state = state.setIn(['provider_evaluation', 'range_eval'], action.payload.range_eval)

            if (action.payload.accumulate['puntaje_total'] >= action.payload.range_eval["aprobo"]) {
                state = state.setIn(['provider_evaluation', 'state_eval'], "Aprobado");
            } else if (action.payload.accumulate['puntaje_total'] <= action.payload.range_eval["no_aprobo"]) {
                state = state.setIn(['provider_evaluation', 'state_eval'], "No aprobado");
            } else {
                state = state.setIn(['provider_evaluation', 'state_eval'], "Aprobado con seguimiento");
            }
            return state;
        case types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_REPORTES:
            state = state.setIn([action.payload.reportToGet, 'modalFilter', 'show'], action.payload.state);
            state = state.setIn([action.payload.reportToGet, 'modalFilter', 'columns'], Immutable.fromJS(action.payload.tableCols));
            state = state.setIn(['reportToGet'], action.payload.reportToGet);
            return state;
        case types.ADICIONAR_CRITERIO_FILTRADO_REPORTES:

            const firstCol = state.getIn([reportToGet, 'modalFilter', 'columns']).first();
            let value = false
            if (firstCol.get('enums')) {
                value = firstCol.getIn(['enums', 0, 'value'])
            }
            state = state.updateIn([reportToGet, 'modalFilter', 'filters'], filter => filter.push(Immutable.fromJS({
                column: firstCol.get('value'),
                operator: '===',
                value: value == false ? '' : value,
                checked: false,
                comparison: firstCol.get('type'),
                apply: false
            })));
            return state;

        case types.MODIFICAR_CRITERIO_FILTRADO_REPORTES:
            if (action.payload.attr === 'column') {
                state = state.setIn([reportToGet, 'modalFilter', 'filters', action.payload.index, 'comparison'], columnas.find(x => x.get('value') === action.payload.value).get('type'));
                const enumsColumn = columnas.find(x => x.get('value') === action.payload.value).get('enums')
                if (enumsColumn) {
                    state = state.setIn([reportToGet, 'modalFilter', 'filters', action.payload.index, 'value'], enumsColumn.getIn([0, 'value']))
                }
            }
            state = state.setIn([reportToGet, 'modalFilter', 'filters', action.payload.index, action.payload.attr], action.payload.value);
            return state;

        case types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_REPORTES:
            state = state.setIn([reportToGet, 'modalFilter', 'filters', action.payload.index, 'checked'], action.payload.checked);
            return state;
        case types.ELIMINAR_CRITERIO_FILTRADO_REPORTES:
            state = state.setIn([reportToGet, 'modalFilter', 'filters'],
                                state.getIn([reportToGet, 'modalFilter', 'filters'])
                                    .filter(item => !item.get('checked'))
                                );
            return state
        case types.APLICAR_CRITERIOS_FILTRADO_REPORTES:
            state = state.updateIn([reportToGet, 'modalFilter', 'filters'], filter => filter
                .map(filterColumn => {
                    filterColumn = filterColumn.set('apply', true);
                    return filterColumn;
                })
            );
            return state
        case types.OBTENER_MONTO_CONTRATADO_PROVEEDOR:
            state = state.setIn(['contracted_amount_providers', 'data'], Immutable.fromJS(action.payload.data))
            state = state.setIn(['contracted_amount_providers', 'page'], action.payload.page);
            state = state.setIn(['contracted_amount_providers', 'totalRecords'], action.payload.totalRecords);
            return state;


        case types.OBTENER_MONTO_CONTRATADO_CENCO:
            state = state.setIn(['contracted_amount_cencos', 'data'], Immutable.fromJS(action.payload.data))
            state = state.setIn(['contracted_amount_cencos', 'page'], action.payload.page);
            state = state.setIn(['contracted_amount_cencos', 'totalRecords'], action.payload.totalRecords);
            return state;

        // case types.OBTENER_CUMPLIMIENTO_RESPONSABLE_COMPRAS:
        //     if (isPrimitive(action.data)) {
        //         state = state.setIn(['compliance_purchasing_manager', 'data'], action.data);
        //     } else {
        //         state = state.setIn(['compliance_purchasing_manager', 'data'], Immutable.fromJS(action.data)); 
        //     }
        //     state = state.setIn(['total'], action.total);
        //     return state;



        case types.OBTENER_CUMPLIMIENTO_RESPONSABLE_COMPRAS:
            state = state.setIn(['compliance_purchasing_manager', 'data'], Immutable.fromJS(action.payload.data)); 
            state = state.setIn(['compliance_purchasing_manager', 'page'], action.payload.page);
            state = state.setIn(['compliance_purchasing_manager', 'totalRecords'], action.payload.totalRecords);
            return state;


            
        // case types.OBTENER_GESTION_RESPONSABLE_COMPRAS:
        //     if (isPrimitive(action.data)) {
        //         state = state.setIn(['manage_purchasing_manager', 'data'], action.data);
        //     } else {
        //         state = state.setIn(['manage_purchasing_manager', 'data'], Immutable.fromJS(action.data)); 
        //     }
        //     state = state.setIn(['total'], action.total);
        //     state = state.setIn(['manage_purchasing_manager', 'show_request_type'], !state.get('request_type'))
        //     return state;


        case types.OBTENER_GESTION_RESPONSABLE_COMPRAS:
            state = state.setIn(['manage_purchasing_manager', 'show_request_type'], !state.get('request_type'))
            state = state.setIn(['manage_purchasing_manager', 'data'], Immutable.fromJS(action.payload.data))
            state = state.setIn(['manage_purchasing_manager', 'page'], action.payload.page);
            state = state.setIn(['manage_purchasing_manager', 'totalRecords'], action.payload.totalRecords);
            state = state.setIn(['manage_purchasing_manager', 'accumulate'], Immutable.fromJS(action.payload.accumulate));
            return state;


        // case types.OBTENER_RADICADOS:
        //     if(isPrimitive(action.data)) {
        //         state = state.setIn(['radicados', 'data'], action.data)
        //         state = state.setIn(['total_storage'], action.total)
        //     } else {
        //         state = state.setIn(['radicados', 'data'], Immutable.fromJS(action.data));
        //         state = state.setIn(['total_storage'], Immutable.fromJS(action.total));
        //     }
        //     state = state.setIn(['total'], action.total);
        //     return state;

        case types.OBTENER_RADICADOS:
            state = state.setIn(['radicados', 'data'], Immutable.fromJS(action.data))
            state = state.setIn(['radicados', 'data'], Immutable.fromJS(action.payload.data))
            state = state.setIn(['radicados', 'page'], action.payload.page);
            state = state.setIn(['radicados', 'totalRecords'], action.payload.totalRecords)
            return state;

        default:
            return state;

    }
}



// WEBPACK FOOTER //
// ./src/reducers/reportes.js